import React from "react";
import InvoiceForm from "./forms";

// TODO: CHECK_IT
const EditInvoice: React.FC = () => <InvoiceForm />;

export default EditInvoice;
